"use strict";
var MODULES = {
    INDEX: {
        module_name: 'usergroup_index'
    }
};
module.exports = MODULES;
